'use client';

import { useMandatoryContext } from '@repo/hooks';
import { createContext } from 'react';
export type MarketApyRateMode = 'borrow' | 'supply';
interface ApyCardMarketRateModeValue {
  rateMode: MarketApyRateMode;
  setRateMode: (mode: MarketApyRateMode) => void;
}
const ApyCardMarketRateModeContext = createContext<ApyCardMarketRateModeValue | null>(null);
export const ApyCardMarketRateModeProvider = ApyCardMarketRateModeContext.Provider;

/**
 * Borrow/Lend selection shared by the APY chart and the rate card beneath it, so the
 * chart's toggle also swaps the rate breakdown rather than leaving the two disagreeing.
 */
export const useApyCardMarketRateMode = () => {
  return useMandatoryContext(ApyCardMarketRateModeContext, "ApyCardMarketRateMode");
};